import { dataDelete } from "../../main/data/data";
import { findParent } from "./findParent";
export function removeActiveItem(e) {
    const target = e.target;
    if (target.classList.contains("cp-active__delete")) {
        const item = findParent(target, "cp-active__item");
        if (item) {
            const pageID = target.getAttribute("data-key");
            item.classList.add("cp-active__item--removed");
            dataDelete(`active/${pageID}`);
        }
    }
}
